import { Button } from "./button";
import type { StoryMeta } from "@features/devtools/registry/types";

type Props = React.ComponentProps<typeof Button> & { children?: React.ReactNode };

const meta: StoryMeta<Props> = {
  id: "ui/Button",
  title: "Button",
  group: "UI/Primitives",
  component: Button as any,
  description: "Shadcn-style button with variants and sizes.",
  defaultProps: {
    children: "Click me",
  },
  controls: {
    children: { type: "text", label: "Text" },
    variant: {
      type: "select",
      options: ["default", "destructive", "outline", "secondary", "ghost", "link"],
    },
    size: { type: "select", options: ["sm", "default", "lg", "icon"] },
    disabled: { type: "boolean" },
  },
  variants: [
    { name: "Primary", props: { variant: "default" } },
    { name: "Outline", props: { variant: "outline" } },
    { name: "Destructive", props: { variant: "destructive" } },
  ],
};

export default meta;

